import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
  mutation AbsenceReasons($absenceReason: CreateAbsenceReasonInput!) {
    createAbsenceReason(absenceReason: $absenceReason) {
      message
      teams {
        id
        name
      }
      allTeamsOn
    }
  }
`;

const fieldsName = {
  message: 'T_ABSENCE_REASON_MESSAGE',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function createAbsenceReason(absenceReason) {
  return apollo.client.mutate({
    mutation,
    variables: {
      absenceReason,
    },
  }).then((data) => data.data.createAbsenceReason)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default createAbsenceReason;
